import type { StatsSnapshot } from '../../../stats/gameplay-snapshot';
import { useCurrencyStore } from '../../zustand/useCurrencyStore';
import { useGameStatsStore } from '../../zustand/useGameStatsStore';

export const lumberjackReducer = (scratch: StatsSnapshot) => {
  const lumberjack = scratch.generators.lumberjack;

  // Only update if ticksCount is a multiple of ticksToGenerate
  const ticksToGenerate = lumberjack.ticksToGenerate ?? 1;
  if (useGameStatsStore.getState().getActiveTicksCount() % ticksToGenerate !== 0) {
    return;
  }

  const woodGenerated = lumberjack.owned * lumberjack.baseGeneration;

  // Apply upgrades somehow, somewhere...

  useCurrencyStore.getState().addWood(woodGenerated);

  return;
};
